<div class="post-container mt-3 h-100">
  @if (postLoading$ | async) {
    <app-loading></app-loading>
  }
  @if (videos && videos.length > 0) {
    <div>
      @for (video of videos; track video) {
        <app-vjs-player
          [options]="{
            autoplay: false,
            sources: [{ src: video.href, type: video.type }],
          }"
        ></app-vjs-player>
      }
    </div>
  }
  @if ((!videos || videos.length === 0) && !(postLoading$ | async)) {
    <div>
      {{ "post-video.message.no-videos-available" | translate }}
    </div>
  }
</div>
